import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const CreateNewAppeal = lazy(() => import("@/pages/Appeals/CreateNewAppeal"));
const CreateAppealByStaff = lazy(() => import("@/pages/Appeals/CreateAppealByStaff"));
const OpenedAppeal = lazy(() => import("@/pages/Appeals/OpenedAppeal"));

const urlsConfig = new UrlsConfig();

export function appealsRoutes() {
    return (
      <>
          <Route path={urlsConfig.appealsCreate.to} element={<CreateNewAppeal/>}/>
          <Route path={urlsConfig.appealsCreateByStaff.to} element={<CreateAppealByStaff/>}/>
          <Route path={`${urlsConfig.appealsView.to}/:number`} element={<OpenedAppeal/>}/>
      </>
    );
}
